import type { BlogCategory } from '~/graphql/generated/schema-types';
import { defineStore } from 'pinia';

export const useBlogStore = defineStore('blogStore', () => {
  const categories = ref([] as BlogCategory[]);

  return {
    categories,
  };
});
